import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import {AllOrdersContent} from './AllOrdersContent';
import {AllOrdersReportProps} from './AllOrdersReport.types';
import {generateAllOrders} from './AllOrdersReport.util';
import reportPayload from './reportPayload';

export const AllOrdersReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {}, // Default to an empty function
  reportHeading = '',
}: AllOrdersReportProps) => {
  const {heading, body} = generateAllOrders({tt});

  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Orders')}
      webInlineInfoHeader={true}
      infoData={{
        header: heading,
        body: body,
      }}
      contentProps={{loadingData, showRecordPopover, reportHeading}}
      contentComponent={AllOrdersContent}
    />
  );
};

export default withHOC(
  withTranslation('report.allFrontlineOrders'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(AllOrdersReport);
